export default __webpack_public_path__ + "static/media/IFROGZ.ce34dbde.svg";